
import { ID } from "common/entities/IEntity";
import * as React from "react";

import Loading from "common/fragments/Loading";
import NonIdealState from "common/fragments/NonIdealState";
import { BlockView } from "common/views/block/BlockView.view";
import { PanelSetupRequired } from "core/components/editor/EditToggle";
import { isEmpty } from "core/util/ArrayUtils";
import { CourseWrapper } from "../../common/entities/courseWrapper/CourseWrapper";
import { TextStoreRenderer } from "../../common/fragments/TextContent";
import { ButtonVariant, ButtonView } from "../../common/views/button/Button.view";
import { Query } from "../../core/api/typedQuery";
import { IPanelProps, Panel } from "../../core/decorators/Panel";
import { iDef, nDef } from "../../core/util/TypeUtils";
import Entry from "./entities/Entry";
import labelProvider from './Featured.labels';
import { FeaturedPanelConfig } from "./FeaturedPanelConfig";

const { Labels } = labelProvider;
interface IEntryQueryParams {
	ids: ID[];
}

const EntryQuery = Query.queryMany<Entry, IEntryQueryParams>(Entry);

@Panel({id: "featured", configClass: FeaturedPanelConfig, labelProvider})
class FeaturedEntriesPanel extends React.Component<IPanelProps<FeaturedPanelConfig>> {

	public render() {
		const { entryIds } = this.props.config;

		if(nDef(entryIds) || entryIds.length < 1) {
			return (
				<PanelSetupRequired description="Specify a catalog entry to get started." />
			);
		}

		return (
			<EntryQuery params={{ids: entryIds}}>
				{
					({data, loading}) => {

						if(loading) {
							return <Loading />;
						}

						if (isEmpty(data)) {
							return (
								<NonIdealState
									title={<Labels.FeaturedCoursesEmpty/>}
									description={<Labels.DescriptionEmpty />}
								/>
							);
						}

						return data.map(this.renderFeatured);
					}
				}
			</EntryQuery>
		);
	}

	private renderFeatured = (entry: Entry) => {
		const { launchLinkText, spacing } = this.props.config;
		const wrapper = CourseWrapper.forEntry(entry);

		if(!wrapper.getLaunchUrl()) {
			return <Labels.CoursePermissionDenied/>;
		}

		const text = `${launchLinkText} ${wrapper.getTitle()}`;
		const margin = iDef(spacing) ? `0 ${spacing} ${spacing} 0` : undefined;

		return (
			<div style={{margin}}>
				<ButtonView variant={ButtonVariant.PRIMARY} viewKey="launch.link" onClick={() => wrapper.launchCourse()}>
					{text}
				</ButtonView>
			</div>
		);
	}
}




// WEBPACK FOOTER //
// ./src/panels/featured/Featured.panel.tsx